import { difference } from "@/lib/lens/handle";
export const getRxSelect = (obj: Record<string, number[]>) => {
    return Object.keys(obj).reduce((pre: any, key: string) => {
        pre[key] = difference({
            min: obj[key][0],
            max: obj[key][1],
            diff: obj[key][2],
            decimalPlaces: obj[key][3], // 保留几位小数的意思（正数表示往后补，负数表示往前补）
            insertType: !!obj[key][4], // true ? unshift : push
            symbol: obj[key][5],
        });
        return pre;
    }, {});
};
